import { BridgeClient } from '@invite/keybox-core';

/** The one bridge to the native shell (`window.InviteNative` / `window.ReactNativeWebView`). */
export const bridge = new BridgeClient();

export const nativeAppPresence = (): Promise<boolean> => bridge.nativeAppPresence();
